import { Helpers } from '@smiles/core-engine';

type FlightResultURL = '/emissao-com-milhas' | '/mfe/emissao-passagem';

/**
 * Here we decide which version of the Flight Result Page we redirect to.
 * /emissao-com-milhas -> old result page
 * /mfe/emissao-passagem -> new page
 * We have 3 conditions:
 * 1. query search parameter ?novo-resultado-voos=true
 * 2. a smiles-core constant (feature flag): ENABLE_NEW_FLIGHT_RESULT
 * 3. Maxymiser configuration (used for A/B testing)
 *    This alternative is effectivelly a simple redirect to the old page,
 *    since Maxymiser does its thing.
 * @author Yehoshua Oliveira <ioxua@newgo.com.br>
 */
export const getFlightResultURLPath = ({
  featureFlagEnabled = Boolean(
    Helpers.getConstants('ENABLE_NEW_FLIGHT_SEARCH')
  ) === true,
} = {}): FlightResultURL => {
  const newPageQueryParam = sessionStorage.getItem('novo-resultado-voos');
  // eslint-disable-next-line no-console
  console.info(`ENABLE_NEW_FLIGHT_SEARCH: ${featureFlagEnabled}`);

  let urlBasePath: FlightResultURL = '/emissao-com-milhas';
  const newUrlBasePath = '/mfe/emissao-passagem';
  if (newPageQueryParam === 'true' || featureFlagEnabled) {
    // eslint-disable-next-line no-console
    console.info('new flight availability ON');
    urlBasePath = newUrlBasePath;
  }
  return urlBasePath;
};
